import { Heading } from "@chakra-ui/react"


export default function FormHeading(props) {
    return (
        <Heading
            as='h4' 
            size='md'
            paddingBottom={1}
        >
            {props.children}
        </Heading>
    )
}
